module.exports = __webpack_public_path__ + "static/media/furniture.a73d5d1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/furniture.svg
// module id = 865
// module chunks = 0